import { transport } from '@opengov/app-core/transport';

import { HasuraResponse } from './types';

export async function executeQuery(query: string, variables: object): Promise<object> {
  return transport
    .url(`/api/data/objects/stories/v1/graphql`)
    .json({ query, variables })
    .post()
    .json()
    .then(liftHasuraResponse);
}

async function liftHasuraResponse(response: HasuraResponse): Promise<object> {
  if (response && response.data) {
    return Promise.resolve(response.data);
  } else {
    return Promise.reject(response.errors);
  }
}
